module.exports = __webpack_public_path__ + "static/media/404-not-found.5b5bba7e.jpg";